import { MenuItem, Select, SelectChangeEvent, SxProps, Theme } from '@mui/material';
import React, { useCallback, useContext } from 'react';
import { FormContext, FormContextType } from '../../../../form/FormContext';
import I18n, { useI18n } from '../../../../i18n/I18n';
import { APPROVAL_STATE_FIELD_NAME_APPROVAL_STRATEGY, APPROVAL_STRATEGIES } from '../../../constants';
import { ApprovalInputViewModel } from '../../../types';

export interface ApprovalStrategySelectProps {
    disabled?: boolean;
    sx?: SxProps<Theme>;
}

export default function ApprovalStrategySelect({ disabled = false, sx }: ApprovalStrategySelectProps) {
    const { state, handleChange } = useContext<FormContextType<ApprovalInputViewModel>>(FormContext);
    const approvalStrategyValue = state.approvalStrategy;

    const approvalStrategySelectLabel = useI18n('approval.strategy.select.label');

    const handleStrategyChange = useCallback(
        (event: SelectChangeEvent<string>) =>
            handleChange(APPROVAL_STATE_FIELD_NAME_APPROVAL_STRATEGY, event.target.value),
        [handleChange]
    );

    return (
        <Select
            sx={sx}
            aria-label={approvalStrategySelectLabel}
            value={approvalStrategyValue}
            onChange={handleStrategyChange}
            size="small"
            variant="standard"
            disabled={disabled}
        >
            <MenuItem value={APPROVAL_STRATEGIES.allApprovalsRequired}>
                <I18n token="approval.strategy.allApprovalsRequired" />
            </MenuItem>

            {/**
             * @todo: Enable this option once the backend support is available.
             */}
            <MenuItem value={APPROVAL_STRATEGIES.anyOneApprovalRequired} disabled>
                <I18n token="approval.strategy.anyOneApprovalRequired" />
            </MenuItem>

            <MenuItem value={APPROVAL_STRATEGIES.allApprovalsRequiredInSequence}>
                <I18n token="approval.strategy.allApprovalsRequiredInSequence" />
            </MenuItem>
        </Select>
    );
}
